import { Provider } from '@angular/core';
import { provideTranslationDictionaryMapping } from '@domgen/dgx-fe-i18n';
import { ArticleSearchTranslation } from '../i18n/article-search-translation.constant';

export function provideArticleSearchI18n(): Provider {
  return [provideTranslationDictionaryMapping(ArticleSearchTranslation)];
}
